// extracted by mini-css-extract-plugin
module.exports = {"trans":"RateCard_trans__3cZJ8","example":"RateCard_example__2sczY","hidescroll":"RateCard_hidescroll__1BwRP","tap":"RateCard_tap__qIP0R"};